
























import { Prop } from "vue-property-decorator";
import Component, { mixins } from "vue-class-component";
import { Route } from "vue-router";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import WithLoadingStatus from "@/mixins/WithLoadingStatus";
import WithParamsUserId from "@/mixins/WithParamsUserId";
import WithFirstLoad from "@/mixins/WithFirstLoad";
import WithUser from "@/mixins/WithUser";
import useRecurring from "@/hooks/useRecurring";
import { WatchRoute } from "@/lib/helpers/customDecorators";
import { $t } from "@/lib/helpers/i18nHelper";
import ConfirmRecurringAction from "@/components/ConfirmRecurringAction";
import BlockAddSubscription from "@/components/BlockAddSubscription";
import BasePageOneColumn from "@/components/BasePageOneColumn.vue";
import QueryPagination from "@/components/QueryPagination.vue";
import PageSubTitle from "@/components/PageSubTitle.vue";
import PageTitle from "@/components/PageTitle.vue";
import GoBack from "@/components/GoBack.vue";
import RecurringTable from "./components/RecurringTable.vue";

@WatchRoute("submitQuerySearch")
@Component({
  name: "PageRecurring",
  components: {
    BasePageOneColumn,
    PageTitle,
    PageSubTitle,
    GoBack,
    QueryPagination,
    RecurringTable,
    ConfirmRecurringAction,
    BlockAddSubscription,
  },
  setup() {
    const {
      response,
      loading,
      subscriptions,
      onCancel,
      getRecurringByProvider,
      getRecurrings,
      getRecurringData,
    } = useRecurring();

    return {
      response,
      loading,
      subscriptions,
      onCancel,
      getRecurringByProvider,
      getRecurrings,
      getRecurringData,
    };
  },
})
export default class PageRecurring extends mixins(WithLoadingStatus, WithUser, WithParamsUserId, WithFirstLoad) {
  public response!: ReturnType<typeof useRecurring>["response"]["value"];
  public loading!: ReturnType<typeof useRecurring>["loading"]["value"];
  public subscriptions!: ReturnType<typeof useRecurring>["subscriptions"]["value"];
  public onCancel!: ReturnType<typeof useRecurring>["onCancel"];
  public getRecurringByProvider!: ReturnType<typeof useRecurring>["getRecurringByProvider"];
  public getRecurrings!: ReturnType<typeof useRecurring>["getRecurrings"];
  public getRecurringData!: ReturnType<typeof useRecurring>["getRecurringData"];

  @Prop({ type: Boolean, default: false })
  public readonly loadSubscribers!: boolean;

  public user: User | null = null;

  public get title() {
    return this.loadSubscribers ? $t("Subscribed to {0}", [this.userName]) : $t("{0}’s subscriptions", [this.userName]);
  }

  public get userName() {
    return this.user?.screenName ?? "...";
  }

  public get userId() {
    return this.paramsUserId;
  }

  public get totalPages() {
    return this.response?.totalPages ?? 0;
  }

  public get getDataFunc() {
    return this.loadSubscribers ? this.getRecurringByProvider : this.getRecurrings;
  }
  public submitQuerySearch(route: Route) {
    const page = Number(route.query.page ?? "0");
    this.loadingStatusShow([
      this.getRecurringData(this.getDataFunc, this.userId, page, 20, [
        "id",
        "amount",
        "consumerId",
        "providerId",
        "expirationTime",
        "recurringBillingScheduleId",
        { consumer: ["screenName"] },
        { provider: ["screenName"] },
        {
          recurringBillingSchedule: [
            "id",
            "cancelled",
            { cost: ["cost", "currency"] },
            { schedule: ["nextBillingTime"] },
          ],
        },
      ]).then(() => this.setFirstLoad()),
      this.userFindById(this.userId).then(r => (this.user = r)),
    ]);
  }

  public updateSubscriptionList() {
    this.submitQuerySearch(this.$route);
  }
}
